import { Label, _decorator } from 'cc';
import LocalizedAsset from './LocalizedAsset';
import { fillTextArgument } from '../../Utils/Utility';

const { ccclass, property, menu } = _decorator;

@ccclass('LocalizedLabel')
@menu('Internationalization/LocalizedLabel')
export default class LocalizedLabel extends LocalizedAsset<Label> {
    @property
    private readonly textTemplate: string = '';

    private _emptyString: string = '';

    /**
     * 更新 key 並設置回退字串。
     * @param messagekey
     * @param emptyString 當 key 對應的訊息不存在時，顯示此內容（預設為空字串）。
     * 如果 emptyString 為空字串，則會直接顯示 messageKey。
     */
    public updateKeyWithFallback(messagekey: string, emptyString: string) {
        this._emptyString = emptyString;
        this.key = messagekey;
    }

    public reset() {
        this.target.string = '';
    }

    protected onKeyChange(): void {
        const [messageKey, ...messageArgs] = this.key.split('|');
        const content = fillTextArgument(this.i18n.getMessage(messageKey) ?? (this._emptyString || messageKey), messageArgs);
        if (this.textTemplate) {
            this.target.string = fillTextArgument(this.textTemplate, [content]);
        } else {
            this.target.string = content;
        }
    }

    protected getTarget(): Label {
        return this.getComponent(Label);
    }
}
